<div class="manage-users-page">
  <h1 class="page-title">Manage Users</h1>
  <p class="page-subtitle">
    Activate or deactivate access. New users appear here automatically the first
    time they sign in.
  </p>

  @if (!permissionsStore.isAdmin()) {
    <div class="not-admin">
      <mat-icon>lock</mat-icon>
      <p>You don't have the right role to manage users. Access is limited to the
         Administrator and System Administrator roles. Contact an administrator if
         you need access.</p>
    </div>
  } @else {
    <div class="toolbar-row">
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Filter by name or email</mat-label>
        <input matInput [ngModel]="filter()" (ngModelChange)="filter.set($event)" />
        @if (filter()) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="filter.set('')">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>

      <button mat-raised-button color="primary" class="add-user-btn" (click)="openAddUserDialog()">
        <mat-icon>person_add</mat-icon>
        Add User
      </button>
    </div>

    @if (loading()) {
      <div class="loading">
        <mat-spinner diameter="36"></mat-spinner>
        <span>Loading users…</span>
      </div>
    } @else if (filteredUsers().length === 0) {
      <p class="empty">No users found.</p>
    } @else {
      <table mat-table [dataSource]="filteredUsers()" class="users-table">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let u">{{ u.shortFriendlyName || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let u">{{ u.email }}</td>
        </ng-container>

        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef>Role</th>
          <td mat-cell *matCellDef="let u">{{ u.role || '—' }}</td>
        </ng-container>

        <ng-container matColumnDef="activated">
          <th mat-header-cell *matHeaderCellDef>Activated</th>
          <td mat-cell *matCellDef="let u">
            <mat-slide-toggle
              [checked]="u.activated"
              [disabled]="isSaving(u.email)"
              (change)="onToggle(u, $event.checked)">
            </mat-slide-toggle>
          </td>
        </ng-container>

        <ng-container matColumnDef="emails">
          <th mat-header-cell *matHeaderCellDef>Emails</th>
          <td mat-cell *matCellDef="let u">
            <button mat-stroked-button
                    class="emails-btn"
                    [matMenuTriggerFor]="emailsMenu"
                    [matMenuTriggerData]="{ user: u }"
                    [disabled]="isSaving(u.email)"
                    matTooltip="Choose which automatic emails this user receives. Scheduled reports always send.">
              {{ emailSummary(u) }}
              <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let u">
            <button mat-icon-button
                    aria-label="Edit name"
                    matTooltip="Edit name"
                    (click)="openEditNameDialog(u)">
              <mat-icon>edit</mat-icon>
            </button>
            @if (!isOwnRow(u.email)) {
              <button mat-icon-button color="warn"
                      aria-label="Remove user"
                      matTooltip="Remove user"
                      [disabled]="isDeleting(u.email)"
                      (click)="confirmDeleteUser(u)">
                <mat-icon>person_remove</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-menu #emailsMenu="matMenu" class="emails-menu">
        <ng-template matMenuContent let-user="user">
          <div class="emails-menu-body" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <div class="emails-menu-title">Automatic emails for {{ user.email }}</div>
            @for (c of emailCategories; track c.key) {
              <mat-checkbox
                [checked]="!isOptedOut(user, c)"
                [disabled]="isSaving(user.email)"
                (change)="onEmailCategoryToggle(user, c, $event.checked, $event.source)">
                <span class="emails-menu-label">{{ c.label }}</span>
                <span class="emails-menu-desc">{{ c.description }}</span>
              </mat-checkbox>
            }
            <div class="emails-menu-note">Scheduled reports always send.</div>
          </div>
        </ng-template>
      </mat-menu>
    }
  }
</div>
